<template>
  <div class="lesson-content">
    <strong class="lesson-id">
      <div><a v-if="$route.query.s" @click="$router.back()" class="back">&#9664; Back</a></div>(ID {{ content.lessonId }})
    </strong>
    <h1 class="lesson-title">
        {{ selectedDayWeekNumber }}. {{ content.name }}
    </h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="complementaryInfo">
              <span class="tag is-primary" :style="`background: ${content.subject.color}`">{{ content.subject.name }}</span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <!-- <div class="level-item">
          <figure v-for="(type,index) in content.types" :key="index" class="image is-48x48">
            <img :src="`/static/img/assets/manual-icons/${types[type]}`"/>
          </figure>
        </div> -->
      </div>
    </nav>
    <div class="lesson-duration"><strong>Suggested duration:</strong> {{ content.duration }}</div>
    <div class="tabs">
      <ul>
        <li @click="() => changeSection(section.id)" v-bind:key="index" v-for="(section, index) in sections" :class="section.id === openSection ? 'is-active' : ''" ><a>{{ section.title }}</a></li>
      </ul>
    </div>
    <div class="lesson-html" :class="openSection" v-html="content[openSection]"></div>
  </div>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      required: true
    },
    selectedDayWeekNumber: {
      type: Number,
      required: true
    }
  },
  watch: {
    $route (to, from) {
      this.openSection = 'intro'
    }
  },
  data () {
    return {
      openSection: 'intro',
      sections: [
        {id: 'intro', title: 'Activities'},
        {id: 'materials', title: 'Materials'},
        {id: 'goals', title: 'Goals'},
        {id: 'evaluation', title: 'Evaluation'}
      ],
      types: {
        'INDEPENDENTWORK': 'independentwork.png',
        'GROUP': 'group.png',
        'DISCUSSION': 'discussion.png',
        'TWOTEAMS': 'twoteams.png',
        'LEARNINGSTATIONS': 'learningstations.png',
        'PARTNERS': 'partners.png',
        'OUTDOORS': 'outdoors.png',
        'SMALLGROUPS': 'smallgroups.png',
        'BONUS': 'bonus.png'
      }
    }
  },
  methods: {
    changeSection: function (section) {
      this.openSection = section
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.tabs li.is-active a {
    border-bottom-color: #e31c79;
    color: #e31c79;
}

.lesson-content {
  font-family: 'Brandon', serif;
  @include text-size-l();
  color: $color-text-dark;

  .level{
    margin-bottom: 1rem;
  }

 .tag{
   font-weight: bold;
 }

  .lesson-duration{
    @include text-size-s();
    margin-bottom: 1rem;
  }

}

.lesson-title {
  margin-bottom: 1rem;
  text-transform: uppercase;
  @include text-size-xxxl();
  font-weight: $font-weight-bold;
}
.complementaryInfo {
  display:block;
}
.lesson-html {

  h1 {
    margin-bottom: 2rem;
  }

  p {
    margin-bottom: 2rem;
  }

  ul {
    list-style-type: initial;
    font-family: 'Brandon', serif!important;
    font-size: 1.25rem!important;
    line-height: 2rem!important;
    color: #221c35!important;
  }

  ul,
  ol {
    margin-left: 10px;
    li {
      display: list-item;
      margin-bottom: 30px;
      color: #221c35;
      // text-transform: lowercase;
    }
  }

  &.goals, &.evaluation{
    & > ul{
      &:first-child > li,
      &:first-child > li {
        color: #e31c79;
        list-style-type: none;
        // text-transform: uppercase;
      }
    }
  }

  &.goals, &.evaluation{
    & > ul{
      &.ul1 > li.li1 {
        color: #e31c79;
        list-style-type: none;
        text-transform: uppercase;
      }
    }
  }

  &.evaluation{
    & > ul li:only-child {
      color: #221c35;
      text-transform: lowercase;
    }
  }

  & > ul li:first-letter {
    text-transform: uppercase;
  }

  &.intro{
    h3{
        color: #e31c79;
        text-transform: uppercase;
    }
  }

}

.social-block,
.orientation-block {
  font-family: 'Averta', $system-fonts;

  h3 {
    font-size: 1.1rem;
    font-weight: bolder;
    color: #0a2239;
  }

  p {
    font-size: 1rem;
    line-height: 1.2rem;
    color: #6B7285;
  }

  a {
    font-size: 0.9rem;
    font-weight: bolder;
    color: #E31C79;
  }
}

.social-block {
  padding: 1rem 0 2rem 0;
}

.orientation-block {
  padding-bottom: 2rem;

  .box {
    border-radius: 0;
    box-shadow: none;
    border: 1px solid #c4c7ce;
    padding: 1rem;
    margin-bottom: 0.6rem;
  }

  h3 {
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0 !important;
  }
}

.activity-group{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/group.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-small-group{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/small-group.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-two-teams{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/two-teams.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-pairs{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/pairs.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-individual{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/individual.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-discussion{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/discussion.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-outdoors{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/outdoors.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-bonus{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/bonus.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

.activity-learning-stations{
    margin-top: 10px;
    padding-left: 50px;
    background: url('/static/img/types/learning-stations.svg') no-repeat top left;
    background-position: 0 5px;
    background-size: 40px 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/ManualContent.vue